<script>
import { Bar } from "vue-chartjs";
import "chartjs-plugin-streaming";
export default {
  extends: Bar,

  mounted() {
    this.renderChart(
      {
        datasets: [
          {
            label: "Online Sales",
            borderColor: "rgba(255, 255, 255, 0.3)",
            backgroundColor: "rgba(255, 255, 255, 0.1)",
            lineTension: 0,
            borderDash: [8, 4]
          },
          {
            label: "Impressions",
            borderColor: "rgba(66, 185, 131, 1.000)",
            backgroundColor: "rgba(66, 185, 131, 0.1)"
          }
        ]
      },
      {
        responsive: true,
        maintainAspectRatio: false,
        color: "#FFFFFF",
        legend: {
          position: "bottom",
          labels: {
            boxWidth: 20,
            usePointStyle: true,
            fontColor: "white"
          }
        },
        scales: {
          fontColor: "white",
          xAxes: [
            {
              ticks: {
                fontColor: "rgba(255,255,255,0.4)",
                stepSize: 3
                // beginAtZero: true
              },
              type: "realtime",
              realtime: {
                duration: 40000,
                refresh: 1000,
                delay: 2000,
                onRefresh: function(chart) {
                  chart.data.datasets.forEach(function(dataset) {
                    dataset.data.push({
                      x: Date.now(),
                      y: Math.random()
                    });
                  });
                }
              }
            }
          ],
          yAxes: [
            {
              ticks: {
                fontColor: "rgba(255,255,255,0.4)",
                stepSize: 0.1,
                beginAtZero: true
              },
              scaleLabel: {
                display: true,
                labelString: "Performance",
                fontColor: "white"
              }
            }
          ]
        }
        // scales: {
        //   xAxes: [
        //     {
        //       type: "realtime",
        //       realtime: {
        //         onRefresh: function(chart) {
        //           chart.data.datasets.forEach(function(dataset) {
        //             dataset.data.push({
        //               x: Date.now(),

        //               y: Math.random()
        //             });
        //           });
        //         },
        //         refresh: 500,
        //         delay: 1000
        //       }
        //     }
        //   ]
        // }
      }
    );
  }
};
</script>
